var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "avatar",
    {
      attrs: {
        initials: _vm.initials,
        src: _vm.imgSrc || _vm.avatarOptions.src,
        "background-color":
          _vm.backgroundColor || _vm.avatarOptions.backgroundColor,
        color: _vm.fontColor || _vm.avatarOptions.color,
        "avatar-size": _vm.avatarSize || _vm.avatarOptions.avatarSize,
        inline: _vm.inline,
        "custom-style": _vm.avatarOptions.customStyle || _vm.stylesOverride,
      },
    },
    [
      _c(
        "svg",
        { staticStyle: { height: "80%" }, attrs: { viewBox: "0 0 35 20" } },
        [
          _c(
            "text",
            {
              attrs: {
                x: "50%",
                y: "50%",
                "dominant-baseline": "central",
                "text-anchor": "middle",
                fill: _vm.fontColor || _vm.avatarOptions.color,
                "font-weight": "300",
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.initials) + "\n    ")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }